var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-option"},[_c('button',{staticClass:"btn btn-block btn-option",on:{"click":_vm.click}},[_c('i',{class:'fas ' + _vm.icon}),_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }